import { gql } from "@apollo/client";
import { TOPIC_BASIC_FIELDS_FRAGMENT } from "../fragments/TopicFragments";

const GET_MY_CLASSES = gql`
  query GetMyClasses($first: Int = 12, $languageId: ID) {
    bookedClasses(first: $first) {
      totalCount
      pageInfo {
        endCursor
        startCursor
        hasPreviousPage
        hasNextPage
      }
      nodes {
        id
        date
        time
        startTime
        classType
        classSize
        category
        seatsRemaining
        bookedAt
        wherebyLink
        language {
          id
          englishName
          realName
          bannerBackground
        }
        teacher {
          id
          avatar
          givenName
          familyName
        }
        topic {
          ...TopicBasicFields
        }
        chapter {
          name
        }
        level {
          title
        }
        city {
          id
          name
        }
        course {
          id
          title
          levelId
          courseType
        }
        participants {
          id
          name
          avatar
          forumProfile
        }
      }
    }
    suggestedClasses(languageId: $languageId) {
      id
      date
      time
      startTime
      classType
      classSize
      category
      seatsRemaining
      bookedAt
      overlapped
      credits
      language {
        id
        englishName
        realName
        bannerBackground
      }
      teacher {
        id
        avatar
        givenName
        familyName
      }
      topic {
        ...TopicBasicFields
      }
      chapter {
        name
      }
      level {
        title
      }
      city {
        id
        name
      }
    }
  }
  ${TOPIC_BASIC_FIELDS_FRAGMENT}
`;

export default GET_MY_CLASSES;
